import React, { useEffect } from 'react'
import {Button, Card, Col, Drawer, Form, Icon, notification, Row, Table, Select, Upload, Tabs} from 'antd'
import _ from 'lodash'
import {FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request, {API_URL} from '../../request'
import {connect} from 'react-redux'
import moment from 'moment'
import { AiFillCheckSquare } from "react-icons/ai";
const Option = Select.Option

@Form.create()
class ViewResignationDetail extends React.Component {
    state = {
        visible: true,
        loading: false,
        leaveApproved:false,
        leaveTypes:['CL(Casual Leave)', 'LWP(Leave Without Pay)', 'HD(Half Day)'],
        allUsers:[],
        record:{}
        
    }



    componentDidMount() {
    }


    onClose = () => {
        setTimeout(() => {
            this.props.onClose()
        }, 400)
    }
    render() {
        const {record} = this.props

        const {
            form: {getFieldDecorator,}
        } = this.props
        
        return (
            <Drawer
                title={
                    <div>
                        <React.Fragment>
                            Detail:- {record.userId.name}
                        </React.Fragment>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                width={500}
                visible={this.state.visible}>
                    <Card>
                    <div style={{textAlign:'center'}}>
            <div style={{marginTop:'10px'}}>
            <table style={{width:'80%', textAlign:'center'}}>
                <tbody>
                    <tr style={{textAlign:'center'}}>
                        <th>Employee Name</th>
                        <td>{record && record.userId.name}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>EmployeeId</th>
                        <td>{ record && record.userId.empId}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Current Address with Pincode</th>
                        <td>{record.lastWorkingDate && moment(record.lastWorkingDate).format('DD-MMMM-YYYY')}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Manager</th>
                        <td>{record && record.manager.name}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>List of Job Responsibilities/Projects</th>
                        <td>{record && record.jobResponsibilitiesOrProjects}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Status of Ongoing Projects/Work</th>
                        <td>{record && record.statusOngoingProjectsOrWork}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Pending Tasks and Deadlines</th>
                        <td>{record && record.pendingTasksAndDeadLines}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Official Email ID</th>
                        <td>{record && record.officialEmail}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Official Email ID Password</th>
                        <td>{record && record.officalEmailPass}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Official Phone Number</th>
                        <td>{record && record.officialPhone}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Official Laptop/Desktop Number</th>
                        <td>{record && record.officialLaptopOrDesktop}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Official Laptop/Desktop Password</th>
                        <td>{record && record.officialLaptopOrDesktopPass}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Laptop’s Charger</th>
                        <td>{record && record.laptopCharger}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Headphones</th>
                        <td>{record && record.headphones}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Mouse</th>
                        <td>{record && record.mouse}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Any other credentials</th>
                        <td>{record && record.anyOtherCredentials}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Please mention here</th>
                        <td>{record && record.credentialsSpecify}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Key Contacts and Relationships</th>
                        <td>{record && record.keyContactsAndRelationships}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Documentation and Files</th>
                        <td>{record && record.documentationAndFiles}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Software and Tools</th>
                        <td>{record && record.softwareAndTools}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Backup and Deletion of Email ID</th>
                        <td>{record && record.backupAndDeletionEmailId}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Deletion from every official group</th>
                        <td>{record && record.deletionOfficialGroup}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Biometric Deactivation</th>
                        <td>{record && record.biometricDeactivation}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Any Drawer or Locker Keys</th>
                        <td>{record && record.drawerOrLockerKeys}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Identity Card</th>
                        <td>{record && record.identityCard}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Any Dues</th>
                        <td>{record && record.anyDues}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Due Specification</th>
                        <td>{record && record.duesSpecify}</td>
                    </tr>
                    <tr style={{textAlign:'center'}}>
                        <th>Additional Notes</th>
                        <td>{record && record.additionalNotes}</td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
                    </Card>
            </Drawer>
        )
    }
}

const mapStateToProps = ({global, router}) => ({
    loading: global.buttonLoading,
    search: router.location.search
})
const mapDispatchToProps = dispatch => {
    return {
        dispatch
    }
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ViewResignationDetail)
